import { FaroTextButton } from "@components/common/faro-text-button";
import { SdbMemberTypes } from "@custom-types/member-types";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { tableTypeSelector } from "@store/table/table-selector";
import { setBulkActionName } from "@store/table/table-slice";
import { getMailHref } from "@utils/email-utils";
import { BulkActionEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { getBulkActionButtonConfig } from "@components/common/faro-table/bulk-actions/bulk-actions-config";
import { Text, EmailIcon } from "@flat-ui";
import { useBulkActionsMode } from "@hooks/use-bulk-actions-mode";

interface Props {
  /** The entities that are selected */
  selectedEntities: SdbMemberTypes[];
}

/** Button to send emails to users in bulk */
export function BulkSendEmail({ selectedEntities }: Props): JSX.Element {
  const { trackEvent } = useTrackEvent();
  const dispatch = useAppDispatch();
  const tableType = useAppSelector(tableTypeSelector);

  const mode = useBulkActionsMode();

  function sendEmail(): void {
    dispatch(setBulkActionName("sendEmail"));

    if (tableType) {
      trackEvent({
        name: BulkActionEvents.bulkSendEmail,
        props: {
          dataType: tableType,
          numberOfEntities: selectedEntities.length,
        },
      });
    }

    window.location.href = getMailHref({
      members: selectedEntities,
    });

    dispatch(setBulkActionName(null));
  }

  const config = getBulkActionButtonConfig(
    mode,
    "Send email to selected members"
  );

  return (
    <FaroTextButton
      onClick={sendEmail}
      tooltipText={config.tooltipText}
      rippleColor={config.rippleColor}
      startIcon={<EmailIcon sx={{ width: "18px", height: "18px" }} />}
      sx={config.sx}
    >
      {config.shouldShowText && <Text variant="buttonM">Send email</Text>}
    </FaroTextButton>
  );
}
